import axios from 'axios';
import * as CONFIG from '../config/index';
import * as helper from './helper';

export const IDEA_PERIOD_API_URL = `${CONFIG.API_URL}/idea-period`;

export const search = async (
  title,
  period,
  userScored,
  status,
  pageNo,
  pageSize
) => {
  try {
    let result = await axios.get(
      IDEA_PERIOD_API_URL +
        '/search?title=' +
        (title ? title : '') +
        '&period=' +
        (period ? period : '') +
        '&userScored=' +
        userScored +
        '&pageNo=' +
        pageNo +
        '&pageSize=' +
        pageSize +
        '&status=' +
        status
    );
    return result.data.data;
  } catch (e) {
    helper.notifyError(e);
    return { items: [], totals: 0 };
  }
};

export const getByIdeaId = async ideaId => {
  try {
    const result = await axios.get(
      `${IDEA_PERIOD_API_URL}/get-by-idea?ideaId=${ideaId}`
    );
    return result.data.data;
  } catch (e) {
    helper.notifyError(e);
    return [];
  }
};

export default {
  search,
  getByIdeaId
};



// WEBPACK FOOTER //
// ./src/common/ideaPeriod.js